const FlyerHeadLogo = ({
    logoData,
    formartedCurrentPeriodeStartDate,
    formartedCurrentPeriodeEndDate,
    flyerSettings
}) => {
    const { flyer_url, flyer_logo_subtitle } = logoData
    const {logo} = flyerSettings
    const logoUrl = logo && logo.url ? logo.url : flyer_url

    return (
        <div>
            {flyer_url && <div className="logo-container"><div className="logo" style={{backgroundImage: `url("${logoUrl}")`}}></div></div>}

            {flyer_logo_subtitle && <div className="flyer-logo-subtitle-container">{flyer_logo_subtitle}</div>}

            {formartedCurrentPeriodeStartDate && formartedCurrentPeriodeEndDate && <div className="week-container-inside">von {formartedCurrentPeriodeStartDate} bis {formartedCurrentPeriodeEndDate}</div>}
        </div>
    )
}

export default FlyerHeadLogo